// confirm map according to the language you input;

import env from '@travel/env';

export const getGoogleMapURL = (languageInfo: string | null | undefined) => {
  const googleMapKey = env('UNIVERSAL_GOOGLE_MAP_API_KEY');
  const mapLanguage = getMapLanguageInfo(languageInfo || 'en-US');
  return `https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places&key=${googleMapKey}&language=${mapLanguage.language}&region=${mapLanguage.region}`;
};

// example: en-US will be ['en', 'US'] which are language and region

export const getMapLanguageInfo = (languageInfo: string | null | undefined) => {
  const languageArray = (languageInfo || 'en-US').split('-');
  // mapLanguage should be 'zh-TW' or 'zh-HK' not only 'zh'
  const isZh = languageArray[0] === 'zh';
  return { language: isZh ? languageInfo : languageArray[0], region: languageArray[1] };
};
